<nb-card>
  <nb-card-header>
    <button
      class="close"
      nbButton
      status="danger"
      size="small"
      (click)="close(true)"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <ng-image-slider
      #nav
      [images]="imageObject"
      [infinite]="false"
      [autoSlide]="1"
      slideImage="1"
      [manageImageRatio]="true"
      [imagePopup]="true"
      [defaultActiveImage]="imgIndex"
      (lightboxClose)="close($event)"
    ></ng-image-slider>
  </nb-card-body>
</nb-card>
